<template>
  <el-form
    :model="form"
    :disabled="disabledForm"
    ref="form">
    <!-- Supplier Quote -->
    <el-row :gutter="24">
      <el-col :lg="4" :md="6" :sm="6" :span="12">
        <el-form-item
          prop="chosen"
          class="material-style margin-bottom-none"
        >
          <el-checkbox
            v-model="form.chosen"
            @change="autoSaveField('chosen')"
          >{{L10n('chosen')}}</el-checkbox>
        </el-form-item>
      </el-col>
      <el-col :lg="2" :md="6" :sm="6" :span="12">
        <el-form-item
          :label="L10n('qty')"
          :rules="getValidationRule('required,numberInteger')"
          prop="qty"
          class="material-style">
          <el-input
            :value="form.qty"
            @input="form.qty = valueNumber($event)"
            @change="autoSaveField('qty')"
          />
        </el-form-item>
      </el-col>
      <el-col :lg="4" :md="6" :sm="12" :span="12">
        <el-form-item
          :label="L10n('part-number')"
          prop="partID"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <select-part-number
            :model.sync="form.partID"
            @on-change="autoSaveField('partID')"
          ></select-part-number>
        </el-form-item>
      </el-col>
      <el-col :lg="4" :md="6" :sm="12" :span="12">
        <el-form-item
          :label="L10n('S/N')"
          prop="partSN"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <el-input
            v-model="form.partSN"
            @change="autoSaveField('partSN')"
          />
        </el-form-item>
      </el-col>
      <el-col :lg="2" :md="8" :sm="12" :span="24">
        <el-form-item
          :label="L10n('price')"
          prop="price"
          class="material-style"
          :rules="getValidationRule('required,number')"
        >
          <el-input
            :value="form.price"
            @input="form.price = valueNumber($event)"
            @change="autoSaveField('price')"
          />
        </el-form-item>
      </el-col>
      <el-col :lg="4" :md="8" :sm="12" :span="24">
        <el-form-item
          prop="currencyID"
          :label="L10n('currency')"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <select-response
            :model.sync="form.currencyID"
            @update:model="autoSaveField('currencyID')"
            :isLoading="dataSourceCurrency.loading"
            :data="dataSourceCurrency.records"
          ></select-response>
        </el-form-item>
      </el-col>
      <el-col :lg="4" :md="8" :sm="12" :span="24">
        <el-form-item
          :label="L10n('condition')"
          prop="conditionID"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <select-response
            :model.sync="form.conditionID"
            @update:model="autoSaveField('conditionID')"
            :isLoading="dataSourceCondition.loading"
            :data="dataSourceCondition.records"
          ></select-response>
        </el-form-item>
      </el-col>
    </el-row>
    <view-more :isApply="!isNew">
      <div class="row">
        <div class="col-xl-2 col-lg-4 col-md-6 col-12">
          <el-form-item
            :label="L10n('release')"
            prop="releaseID"
            class="material-style"
          >
            <select-response
              :model.sync="form.releaseID"
              @on-change="autoSaveField('releaseID')"
              :data="dataSourceRelease.records"
              :isLoading="dataSourceRelease.loading"
            ></select-response>
          </el-form-item>
        </div>
        <div class="col-xl-2 col-lg-4 col-md-6 col-12">
          <el-form-item
            :label="L10n('tag-info-company')"
            prop="tagInfoCompanyID"
            class="material-style"
          >
            <select-company
              :model.sync="form.tagInfoCompanyID"
              @on-change="autoSaveField('tagInfoCompanyID')"
              :disabled="disabledForm"
            >
            </select-company>
          </el-form-item>
        </div>
        <div class="col-xl-2 col-lg-4 col-md-6 col-12">
          <el-form-item
            :label="L10n('traceability-company')"
            prop="traceabilityCompanyID"
            class="material-style"
          >
            <select-company
              :model.sync="form.traceabilityCompanyID"
              @on-change="autoSaveField('traceabilityCompanyID')"
              :disabled="disabledForm"
            >
            </select-company>
          </el-form-item>
        </div>
        <div class="col-xl-2 col-lg-4 col-md-6 col-12">
          <el-form-item
            :label="L10n('tag-date')"
            prop="tagDate"
            class="material-style">
            <date-picker
              v-model="form.tagDate"
              @change="autoSaveField('tagDate')"/>
          </el-form-item>
        </div>
        <div class="col-xl-2 col-lg-4 col-md-6 col-12">
          <el-form-item
            :label="L10n('supply-date')"
            prop="supplyDate"
            class="material-style"
          >
            <el-input
              v-model="form.supplyDate"
              @change="autoSaveField('supplyDate')"
            />
          </el-form-item>
        </div>
        <div class="col-xl-2 col-lg-4 col-md-6 col-12">
          <el-form-item
            :label="L10n('stock')"
            prop="stockID"
            class="material-style"
          >
            <select-response-auto-complete
              :model.sync="form.stockID"
              @on-change="autoSaveField('stockID')"
              searchAllColumns
              :columns="stockColumns"
              api="Stocks/GetAllDynamic"
              selected="id,supplierCompany.name as supplierCompanyName,partPrice,priceCurrency.title as priceCurrencyTitle,ownerCompany.name as ownerCompanyName,condition.title as conditionTitle"
              :fields="{id: 'id', title: 'supplierCompanyName'}"
              :orderBy="{ fields: 'supplierCompany.name', order: 'desc'}"
            >
            </select-response-auto-complete>
          </el-form-item>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-4 col-lg-4 col-md-6 col-12">
          <el-form-item
            :label="L10n('exchange-core-value')"
            prop="exchangeCoreValue"
            class="material-style"
            :rules="getValidationRule('number')"
          >
            <el-input
              :value="form.exchangeCoreValue"
              @input="form.exchangeCoreValue = valueNumber($event)"
              @change="autoSaveField('exchangeCoreValue')"
            />
          </el-form-item>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-12">
          <el-form-item
            :label="L10n('currency')"
            prop="exchangeCoreValueCurrencyID"
            class="material-style"
          >
            <select-response
              :model.sync="form.exchangeCoreValueCurrencyID"
              @on-change="autoSaveField('exchangeCoreValueCurrencyID')"
              :isLoading="dataSourceCurrency.loading"
              :data="dataSourceCurrency.records"
            ></select-response>
          </el-form-item>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-12">
          <el-form-item
            :label="L10n('exchange-condition')"
            prop="exchangeConditionID"
            class="material-style"
          >
            <select-response
              :model.sync="form.exchangeConditionID"
              @on-change="autoSaveField('exchangeConditionID')"
              :isLoading="dataSourceCondition.loading"
              :data="dataSourceCondition.records"
            ></select-response>
          </el-form-item>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-2 col-lg-3 col-md-4 col-12">
          <el-form-item
            :label="L10n('core-due-date')"
            prop="coreDueDate"
            class="material-style">
            <date-picker
              v-model="form.coreDueDate"
              @change="autoSaveField('coreDueDate')"/>
          </el-form-item>
        </div>
        <div class="col-xl col-lg col-md col-12">
          <el-form-item
            :label="L10n('remarks')"
            prop="remarks"
            class="material-style">
            <el-input
              :value="form.remarks"
              @input="form.remarks = valueTrimLeft($event)"
              @change="autoSaveField('remarks')"/>
          </el-form-item>
        </div>
        <div class="col-auto">
          <el-form-item
            prop="exchangeCoreReceived"
            class="material-style"
          >
            <el-checkbox
              v-model="form.exchangeCoreReceived"
              @change="autoSaveField('exchangeCoreReceived')"
            >{{L10n('exchange-core-received')}}</el-checkbox>
          </el-form-item>
        </div>
        <div class="col-auto">
          <el-form-item
            prop="sendMail"
            class="material-style"
          >
            <el-checkbox
              v-model="form.sendMail"
              @change="autoSaveField('sendMail')"
            >{{L10n('send-mail')}}</el-checkbox>
          </el-form-item>
        </div>
      </div>
      <form-controls
        v-if="!isNew"
        :isSave="!disabled"
        :isDelete="!disabled"
        @command="handlerCommand"
      >
        <div class="control btn-mobile-full" style="order: 2" v-if="withClone">
          <button
            type="button"
            class="btn btn-control btn-size-s btn-mobile-full"
            @click.prevent="handleDuplicate">
            {{L10n('duplicate')}}
          </button>
        </div>
        <div class="control btn-mobile-full" style="order: 3" v-if="withDownload">
          <logo-button
            class="btn-mobile-full"
            @click="handleDownload"
            :getPdfContent="getPdfContent"
          >
            {{L10n('download-slip')}}
          </logo-button>
        </div>
      </form-controls>
    </view-more>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'
import mixListForm from '@/components/ListForm/mixForm'
import { ServicePdf } from '@/services/pdf-generators'

export default {
  name: 'FormSupplierQuoteRFQ',
  mixins: [mixListForm, Form],
  components: {
    'view-more': () => import(/* webpackChunkName: 'UI' */ '@/components/UI/ViewMore.vue'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls'),
    'select-part-number': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectPartNumber/Index.vue'),
    'select-company': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompany/Index.vue'),
    'logo-button': () => import(/* webpackChunkName: 'UI' */ '@/components/Shared/LogoButton')
  },
  props: {
    isNew: { type: Boolean, required: true },
    withClone: { type: Boolean, default: false },
    withDownload: { type: Boolean, default: false }
  },
  computed: {
    dataSourceCurrency () {
      return this.API('Currencies/GetAllDynamic?select=id,title')
    },
    dataSourceCondition () {
      return this.API('Conditions/GetAllDynamic?select=id,title&orderBy=title asc')
    },
    dataSourceRelease () {
      return this.API('Releases/GetAllDynamic?select=id,title')
    },
    stockColumns () {
      return [
        { title: this.L10n('supplier-company'), value: 'supplierCompanyName', type: 'string', originField: 'supplierCompany.name' },
        {
          title: this.L10n('price'),
          // eslint-disable-next-line
          template: "${data.partPrice ? data.partPrice: ''} ${data.priceCurrencyTitle ? data.priceCurrencyTitle: ''}",
          type: 'number',
          originField: 'partPrice'
        },
        { title: this.L10n('owner-company'), value: 'ownerCompanyName', type: 'string', originField: 'ownerCompany.name' },
        { title: this.L10n('condition'), value: 'conditionTitle', type: 'string', originField: 'condition.title' }
      ]
    }
  },
  methods: {
    getPdfContent () {
      const translate = this.L10n
      return ServicePdf.generatePackingSlipContent({ id: this.data.id, translate })
    },
    handleDuplicate () {
      this.$emit('command', 'clone')
    },
    handleDownload (logoKey) {
      this.$emit('download', { id: this.data.id, logoKey })
    },
    handlerCommand (command) {
      this.$emit('command', command)
    }
  }
}
</script>
